import React, { useCallback } from 'react';
import PropTypes              from 'prop-types';
import { Table, Button }      from 'semantic-ui-react';

import DataGroupSelector  from './DataGroupSelector';

// -----------------------------------------------------
// Helpers
// -----------------------------------------------------

const dataGroupFieldName = 'data_group_id';

// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

const DataGroupField = ({ id, dataGroupId, selectedDataGroupIds, onChange, onRemove }) => {
  const handleChange  = useCallback((evt, { name, value }) => {
    onChange({ id, [name]: value });
  }, [id, onChange]);

  const handleRemove  = useCallback(() => {
    onRemove(id);
  }, [id, onRemove]);

  return (
    <Table.Row>
      <Table.Cell>
        <DataGroupSelector  name={ dataGroupFieldName }
                            value={ dataGroupId }
                            selectedDataGroupIds={ selectedDataGroupIds }
                            onChange={ handleChange } />
      </Table.Cell>
      <Table.Cell textAlign='right'>
        <Button icon='remove'
                size='mini'
                basic
                color='red'
                onClick={ handleRemove } />
      </Table.Cell>
    </Table.Row>
  );
};

// -----------------------------------------------------
// PropTypes
// -----------------------------------------------------

DataGroupField.defaultProps = {

};

DataGroupField.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,

  dataGroupId:          PropTypes.number,
  onRemove:             PropTypes.func.isRequired,
  onChange:             PropTypes.func.isRequired,
  selectedDataGroupIds: PropTypes.arrayOf(PropTypes.number)
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

export default DataGroupField;
